import { CHECKLIST_ITEM_TYPE } from 'src/constants/tasksV2';

export default {
    id: 13,
    type: CHECKLIST_ITEM_TYPE.SEND_PAYMENT_LINK,
    manifestKey: 'SEND_PAYMENT_LINK',

    try_it: {
        button_label: 'Send Payment Link',
        cell_component_import: {
            from: 'src/pages/dashboard/tables/AllLeadTable/TaskChecklistField',
            named: 'SendPaymentLinkCell',
        },
        prefill: {
            completion_state: 'YES',
            response_payload: { method: 'manual', amount_pence: 5000 },
        },
    },
    pre_flight_diff: [
        'Step 1: Stripe payment link generated OR manual acknowledgement selected',
        'Step 2: POST /checklist/{iid}/complete/ — checklist item: PENDING → YES',
        'task_payment_link_sent Action logged to lead timeline',
        '⚠ Unit risk: amount_pence must be in pence (5000 = £50.00), NOT pounds',
        'Role gate: ADMIN or TCO only — USER role returns 403',
    ],
    has_step2_throttle: true,
    validation_laboratory: null,
};
